import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { sendTrackingInfo } from '@panel/commons';
import { ModalCreditsOptions } from '@panel/commons/lib/Modals/ModalCreditsOptions';

function NormalFlowDraftToOnCreditsYesComplete(props) {
  const { onClickCancel, onClickAction, onClickSelect, plans, defaultPlan } = props;
  const { t } = useTranslation();

  useEffect(() => {
    sendTrackingInfo('Mis avisos', 'Publicar Aviso con Datos completos_con credito-Intencion');
  }, []);

  return (
    <ModalCreditsOptions
      onClickAction={onClickAction}
      onClickCancel={onClickCancel}
      onClickSelect={onClickSelect}
      onClickOutside={onClickCancel}
      plans={plans}
      defaultPlan={defaultPlan}
      title={t('panel.modal.NormalFlowDraftToOnCreditsYes.title')}
      subTitle={t('panel.modal.NormalFlowDraftToOnCreditsYes.subtitle')}
      ctaCancel={t('panel.modal.cta.cancel')}
      ctaOk={t('panel.modal.cta.publish')}
    />
  );
}

export { NormalFlowDraftToOnCreditsYesComplete };
